import React, { FC } from 'react';
import cls from './DaysMode.module.css';
import classNames from 'classnames';
import { DaysModeHeader } from './DaysModeHeader/DaysModeHeader';
import { DaysModeBody } from './DaysModeBody/DaysModeBody';

export const DaysMode = ({ stages, isBlur, classes }) => {
    return (
        <div className={classNames(cls.DaysMode, { [classes]: isBlur })}>
            <DaysModeHeader />
            <DaysModeBody stages={stages} />
        </div>
    );
};
